import { jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from "react";
const OtpContext = /*#__PURE__*/ createContext(void 0);
const OtpContextProvider = ({ handleOtpSubmit, children })=>{
    const [otpFormData, setOtpFormData] = useState();
    const [otpDeliveryType, setOtpDeliveryType] = useState();
    const [otpDeliveryMethodUsed, setOtpDeliveryMethodUsed] = useState();
    const [showOtpVerificationForm, setShowOtpVerificationForm] = useState(false);
    const [verificationApiFunction, setVerificationApiFunction] = useState();
    const [resendInProgress, setResendInProgress] = useState(false);
    const [otpResent, setOtpResent] = useState(false);
    const [otpRequestErrorMsg, setOtpRequestErrorMsg] = useState('');
    const value = {
        otpRequestErrorMsg,
        setOtpRequestErrorMsg,
        otpResent,
        setOtpResent,
        resendInProgress,
        setResendInProgress,
        otpDeliveryType,
        setOtpDeliveryType,
        otpFormData,
        setOtpFormData,
        showOtpVerificationForm,
        setShowOtpVerificationForm,
        verificationApiFunction,
        setVerificationApiFunction,
        handleOtpSubmit,
        otpDeliveryMethodUsed,
        setOtpDeliveryMethodUsed
    };
    return /*#__PURE__*/ jsx(OtpContext.Provider, {
        value: value,
        children: children
    });
};
const useOtpContext = ()=>{
    const context = useContext(OtpContext);
    if (!context) throw new Error('useOtpContext must be used within an OtpContextProvider');
    return context;
};
export { OtpContextProvider, useOtpContext };
